module.exports = __webpack_public_path__ + "img/111.7c9e47ef.svg";